// automatically generated by the FlatBuffers compiler, do not modify

export enum Units{
  Millimeters = 0,
  Micrometers = 1,
  Nanometers = 2
}

